<template>
    <div class="app-content">
        <div class="iframe-content">
            <iframe id="bimIframeId" :src="url" frameborder="0" @load="onLoad"></iframe>
        </div>
        <div class="detail-content">
            <div class="detail-content-title">模型</div>
            <div class="detail-content-button">
                <button @click="initializeIModel">初始化</button>
                <button @click="setWholeTransparency">设置模型透明</button>
                <button @click="clearTransparencyAll">恢复模型透明</button>
                <button @click="setModelColor">设置模型颜色</button>
                <button @click="resetModelColor">恢复模型颜色</button>
                <button @click="clipXAxis">X轴面剖切</button>
                <button @click="clipYAxis">Y轴面剖切</button>
                <button @click="clipZAxis">Z轴面剖切</button>
                <button @click="showClip">显示剖切</button>
                <button @click="hideClip">隐藏剖切</button>
                <button @click="clearClip">删除剖切</button>
                <button @click="projectLocationShow">开启包围盒</button>
                <button @click="projectLocationHide">关闭包围盒</button>
            </div>
            <hr />
            <div class="detail-content-title">构件</div>
            <div class="detail-content-button">
                <button @click="selectElement">点选构件</button>
                <button @click="showAllCategories">显示构件</button>
                <button @click="hideAllCategories">隐藏构件</button>
                <button @click="hideAllCategories">关闭构件显示</button>
                <button @click="hideElements">仅隐藏指定构件</button>
                <button @click="clearHiddenElements">仅显示指定构件</button>
                <button @click="clearHidden">恢复模型</button>
                <button @click="setElementColor">设置构件颜色</button>
                <button @click="clearElementColor">恢复构件颜色</button>
                <button @click="setElementTransparency">设置构件透明</button>
                <button @click="clearElementTransparency">恢复构件透明</button>
                <button @click="clearElementTransparency">恢复构件透明</button>
                <button @click="findElementIds">查找构件</button>
                <button @click="zoomToElements">定位构件</button>
                <button @click="highLight">高亮显示构件</button>
                <button @click="rotateElements">开启、关闭构件旋转</button>
                <button @click="moveElements">开启、关闭构件偏移</button>
            </div>
            <hr />
            <div class="detail-content-title">模型展示视角</div>
            <div class="detail-content-button">
                <button @click="viewRotationFront">前视图</button>
                <button @click="viewRotationBack">后视图</button>
                <button @click="viewRotationLeft">左视图</button>
                <button @click="viewRotationRight">右视图</button>
                <button @click="viewRotationTop">顶视图</button>
                <button @click="viewRotationBottom">底视图</button>
            </div>

            <div class="detail-content-title">视角设置</div>
            <div class="detail-content-button">
                <button @click="SaveOrUpdateView({ viewName: 'viewname' })">
                    设置默认视点（保存缩略图）
                </button>
                <button @click="reloadView({ viewName: 'viewname' })">
                    恢复默认视图
                </button>
            </div>

            <div class="detail-content-title">自定义标签</div>
            <div class="detail-content-button">
                <input id="file-input0" type="file" @change="loadPictureMark" style="display: none" />
                <button @click="triggerFileInput('file-input0')">加载图片标签</button>
                <button @click="loadTextMark">加载文字标签</button>
                <button @click="deleteAllMarks">删除全部</button>
                <button @click="showMarks">显示标签</button>
                <button @click="zoomToMark">调整相机位置（定位到标签）</button>
            </div>

            <div class="detail-content-title">自定义视点漫游</div>
            <div class="detail-content-button">
                <button @click="addKeyframePath">添加关键帧路径</button>
                <button @click="addKeyframe">添加关键帧</button>
                <button @click="createTrackFromPts">创建轨迹漫游</button>
                <button @click="getTrackSpeed">轨迹漫游移动速度</button>
                <button @click="getRoamingTime">漫游总时间</button>
                <button @click="getKeyframeRoamingTime">关键帧运动时间</button>
                <button @click="startKeyframeRoaming">开始关键帧漫游</button>
                <button @click="startTrackRoaming">开始轨迹漫游</button>
                <button @click="flyRoaming">飞行漫游</button>
            </div>

            <div class="detail-content-title">测量相关</div>
            <div class="detail-content-button">
                <button @click="measureDistance">测量距离</button>
                <button @click="measureLocation">位置测量</button>
                <button @click="measureArea">面积测量</button>
                <button @click="measureLength">长度测量</button>
                <button @click="measureVolume">体积测量</button>
            </div>

            <div class="detail-content-title">模型及构件效果</div>
            <div class="detail-content-button">
                <button @click="dropAllEffect">取消所有效果</button>
                <button @click="openSaturation">打开饱和度</button>
                <button @click="setSaturation">设置饱和度</button>
                <button @click="closeSaturation">关闭饱和度</button>
                <button @click="openLensDistortion">打开透镜畸变</button>
                <button @click="setLensAngle">设置透视角度</button>
                <button @click="closeLensDistortion">关闭透镜畸变</button>
                <button @click="openVignette">打开小插图</button>
                <button @click="closeVignette">关闭小插图</button>
                <button @click="setStrength">设置强度</button>
                <button @click="setCylindricalRatio">
                    设置圆柱比例
                </button>
                <button @click="setSize">设置大小</button>
                <button @click="setSmoothness">设置光滑度</button>
                <button @click="setRoundness">设置圆度</button>
                <button @click="convertCoordinates">二三维坐标转换</button>
                <button @click="elementMove">构件按自定义路径移动（物体漫游）</button>
            </div>
            <hr />
            <div class="detail-content-title">gis</div>
            <div class="detail-content-button">
                <button @click="setGeographicCRS">设置地理坐标系</button>
                <input id="file-input1" type="file" accept=".prj" @change="importGeographicCRS" style="display: none" />
                <button @click="triggerFileInput('file-input1')">导入PRJ文件</button>
                <input id="file-input2" type="file" accept=".kml" @change="createDecoratorFromKml"
                    style="display: none" />
                <button @click="triggerFileInput('file-input2')">导入Kml数据</button>
                <button @click="openMap">开启地图</button>
                <button @click="closeMap">关闭地图</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            // iframe地址： 模型后台域名+模型地址
            url: "https://view.bimwindows.cn/?hIIQAKzrJI+abHXkDEVRpXowhQiMNuZjGx5jN12Y03Gw6NbG+X24uOJyMfMrzi5h6y1z/Z43/zmdgmrtMOa3hdY95QdbZ7rTKVNjyL+uYB2vNrGB/YPNY3B9/ZSUNwoMK2R8qN9zmWACUmGjXUO920X8/E3GI4yI2/oSenL31f8=?editable",
        };
    },
    methods: {
        onLoad() {
            console.log("onLoad");
        },
        async initializeIModel() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.initializeIModel",
                    data: null, // 无参数传 null
                },
                (result) => {
                    console.log(result);
                    

                }
            );
        },
        async setWholeTransparency() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.setWholeTransparency",
                    data: { opacity: 0.5 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async clearTransparencyAll() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.clearTransparencyAll",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async setModelColor() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.setModelColor",
                    data: { r: 0, g: 0, b: 255 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        resetModelColor() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.resetModelColor",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async clipXAxis() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.ClipXAxis",
                    data: {
                        pointx: 2.13,
                        pointy: 3.19,
                        pointz: 4.34,
                        clearExistingPlanes: true,
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async clipYAxis() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.ClipYAxis",
                    data: {
                        pointx: 2.13,
                        pointy: 3.19,
                        pointz: 4.34,
                        clearExistingPlanes: true,
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async clipZAxis() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.ClipZAxis",
                    data: {
                        pointx: 2.13,
                        pointy: 3.19,
                        pointz: 4.34,
                        clearExistingPlanes: true,
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        showClip() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.showClip",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        hideClip() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.hideClip",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        clearClip() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.clearClip",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        projectLocationShow() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.ProjectLocationShow",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        projectLocationHide() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.ProjectLocationHide",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },

        //  ------------------

        selectElement() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.selectElement",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async showAllCategories() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.showAllCategories",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async hideAllCategories() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.hideAllCategories",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        hideElements() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.hideElements",
                    data: { Ids: ["0x215", "0x21f"] },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async clearHiddenElements() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.clearHiddenElements",
                    data: { Ids: ["0x215", "0x21f"] },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        clearHidden() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.clearHidden",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setElementColor() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.setElementColor",
                    data: {
                        Ids: ["0x215", "0x21f"],
                        red: 0,
                        green: 0,
                        blue: 255,
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        clearElementColor() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.clearElementColor",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setElementTransparency() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.setElementTransparency",
                    data: {
                        Ids: ["0x215", "0x21f"],
                        transparency: 0.8,
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async clearElementTransparency() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.clearElementTransparency",
                    data: {
                        Ids: ["0x215", "0x21f"],
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async findElementIds() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.findElementIds",
                    data: { userLabel: "装饰墙 2" },
                },
                (result) => {
                    console.log(result);
                    this.$postKsjMessage(
                        {
                            commandName: "KSJElementApi.zoomToElements",
                            data: { Ids: result },
                        },
                        (result) => {
                            console.log(result);
                        }
                    );
                }
            );
        },
        zoomToElements() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.zoomToElements",
                    data: { Ids: ["0x21f"] },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        highLight() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.highLight",
                    data: { Ids: ["0x21f"] },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async rotateElements() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.RotateElements",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async moveElements() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.MoveElements",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        // --------------------------------
        viewRotationFront() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.viewRotationFront",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        viewRotationBack() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.viewRotationBack",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        viewRotationLeft() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.viewRotationLeft",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        viewRotationRight() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.viewRotationRight",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        viewRotationTop() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.viewRotationTop",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        viewRotationBottom() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.viewRotationBottom",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        saveOrUpdateView() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.SaveOrUpdateView",
                    data: { viewName: "viewname" },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        reloadView() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.reloadView",
                    data: { viewName: "viewname" },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async loadPictureMark(event) {
            const files = event.target.files;
            if (files && files.length > 0) {
                const file = files[0];
                // 将图片File转为Base64
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    // 添加图片标签
                    this.$postKsjMessage(
                        {
                            commandName: "KSJMarkerApi.createPrctureMarkObj",
                            data: {
                                view: 1,
                                markType: "位置",
                                markName: "图片标签",
                                markNote: "",
                                picture: reader.result,
                                pointx: 17.59,
                                pointy: -5.42,
                                pointz: 4.5,
                            },
                        },
                        (result) => {
                            console.log(result);
                        }
                    );
                };
            }
        },
        async loadTextMark() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMarkerApi.createTextMarkObj",
                    data: {
                        view: 1,
                        markType: "位置",
                        markName: "文字标签222",
                        markNote: "文字标签",
                        text: "文字标签",
                        pointx: 17.59,
                        pointy: -5.42,
                        pointz: 4.5,
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async deleteAllMarks() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMarkerApi.deleteAllMarkObj",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async showMarks() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMarkerApi.showMarksObjs",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async zoomToMark() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMarkerApi.zoomToByName",
                    data: {
                        name: "图片标签",
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async addKeyframePath() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.setWorkingIModel",
                    data: null,
                },
                () => {
                    this.$postKsjMessage(
                        {
                            commandName: "KSJKeyframeRoamingApi.createTrack",
                            data: { roadName: "关键帧漫游" },
                        },
                        (result) => {
                            console.log(result);
                        }
                    );
                }
            );
        },
        async addKeyframe() {
            this.$postKsjMessage(
                {
                    commandName: "KSJKeyframeRoamingApi.AddKeyFrame",
                    data: {
                        roadName: "关键帧漫游",
                        tim: 10,
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async createTrackFromPts() {
            this.$postKsjMessage(
                {
                    commandName: "KSJModelControlApi.setWorkingIModel",
                    data: null,
                },
                () => {
                    this.$postKsjMessage(
                        {
                            commandName: "KSJPathRoamingApi.createTrackFromPts",
                            data: {
                                roadName: "轨迹漫游",
                                points: [
                                    { pointx: 31.64, pointy: -8.9, pointz: 0 },
                                    { pointx: 0, pointy: 0, pointz: 0 },
                                    { pointx: -25.25, pointy: -8.9, pointz: 0 },
                                    { pointx: -100, pointy: -8.9, pointz: 0 },
                                ],
                            },
                        },
                        (result) => {
                            console.log(result);
                        }
                    );
                }
            );
        },
        async getTrackSpeed() {
            this.$postKsjMessage(
                {
                    commandName: "KSJPathRoamingApi.GetSpeed",
                    data: { roadName: "轨迹漫游" },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async getRoamingTime() {
            this.$postKsjMessage(
                {
                    commandName: "KSJPathRoamingApi.getRoamingTime",
                    data: { roadName: "轨迹漫游" },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async getKeyframeRoamingTime() {
            this.$postKsjMessage(
                {
                    commandName: "KSJKeyframeRoamingApi.StartKeyframeRoaming",
                    data: { roadName: "关键帧漫游" },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async startKeyframeRoaming() {
            this.$postKsjMessage(
                {
                    commandName: "KSJKeyframeRoamingApi.StartRoaming",
                    data: { roadName: "关键帧漫游" },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        startTrackRoaming() {
            this.$postKsjMessage(
                {
                    commandName: "KSJPathRoamingApi.StartRoaming",
                    data: { roadName: "轨迹漫游" },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        flyRoaming() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.FlyRoaming",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        measureDistance() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMeasureTool.measureDistance",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        measureLocation() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMeasureTool.measureLocation",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        measureArea() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMeasureTool.measureArea",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        measureLength() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMeasureTool.measureLength",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        measureVolume() {
            this.$postKsjMessage(
                {
                    commandName: "KSJMeasureTool.measureVolume",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        dropAllEffect() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.dropAllEffect",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        openSaturation() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.openSaturation",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setSaturation() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.setSaturation",
                    data: { saturation: 4 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        closeSaturation() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.closeSaturation",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        openLensDistortion() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.openLensDistortion",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setLensAngle() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.setLensAngle",
                    data: { lensAngle: 100 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        closeLensDistortion() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.closeLensDistortion",
                    data: { lensAngle: 100 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        openVignette() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.openVignette",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        closeVignette() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.closeVignette",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setStrength() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.setStrength",
                    data: { strength: 0.5 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setCylindricalRatio() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.setCylindricalRatio",
                    data: { cylindricalRatio: 0.5 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setSize() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.setSize",
                    data: { size: 0.5 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setSmoothness() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.setSmoothness",
                    data: { smoothness: 0.5 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        setRoundness() {
            this.$postKsjMessage(
                {
                    commandName: "KSJViewportEffectApi.setRoundness",
                    data: { roundness: 0.5 },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async convertCoordinates() {
            this.$postKsjMessage(
                {
                    commandName: "KSJSceneViewApi.SpaceFloorIframe",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async elementMove() {
            this.$postKsjMessage(
                {
                    commandName: "KSJElementApi.ElementMove",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },

        // --------------------------------
        async setGeographicCRS() {
            this.$postKsjMessage(
                {
                    commandName: "KSJGeographicCRSSettingApi.setGeographicCRS",
                    data: {
                        type: "CGCS2000",
                        projectionType: 1,
                        utmRegion: "1N",
                        scaleFactor: "1",
                        centerLon: "117",
                        falseEasting: "104",
                        falseNorthing: "0",
                        orginLon: "104",
                        orginLat: "0",
                        orginHeight: "0",
                    },
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        async importGeographicCRS(event) {
            const files = event.target.files;
            if (files && files.length > 0) {
                const file = files[0];
                this.$postKsjMessage(
                    {
                        commandName: "KSJGeographicCRSSettingApi.ImportGeographicCRS",
                        data: { file },
                    },
                    (result) => {
                        console.log(result);
                    }
                );
            }
        },
        async createDecoratorFromKml(event) {
            const files = event.target.files;
            if (files && files.length > 0) {
                const file = files[0];
                this.$postKsjMessage(
                    {
                        commandName: "KSJGeographicCRSSettingApi.createDecoratorFromKml",
                        data: { file },
                    },
                    (result) => {
                        console.log(result);
                    }
                );
            }
        },
        triggerFileInput(inputId) {
            document.getElementById(inputId).click();
        },
        openMap() {
            this.$postKsjMessage(
                {
                    commandName: "openMap",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
        closeMap() {
            this.$postKsjMessage(
                {
                    commandName: "closeMap",
                    data: null,
                },
                (result) => {
                    console.log(result);
                }
            );
        },
    },
};
</script>

<style lang="less" scoped>
.app-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .iframe-content {
        height: 100%;
        flex: 1;

        iframe {
            width: 100%;
            height: 100%;
            border: none;
            box-sizing: border-box;
        }
    }

    .detail-content {
        width: 400px;
        border-top: 1px solid #ccc;
        padding: 4px 5px;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
    }

    .detail-content .detail-content-title {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-weight: bold;
        color: black;
    }

    .detail-content .detail-content-button {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
    }
}
</style>
